import { render, staticRenderFns } from "./StudentClassAudit.vue?vue&type=template&id=115afa1e"
import script from "./StudentClassAudit.vue?vue&type=script&lang=js"
export * from "./StudentClassAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports